<div class="container">
  <p class="title">
    {{headerTitle}}
    <span class="tooltip" matTooltipPosition="below" matTooltip="{{tooltip}}">?</span>
  </p>

  <app-audio-player [audio]="audio" [title]="notificationType"></app-audio-player>

  <a class="change-audio" id="change-{{notificationType}}-audio-btn" (click)="showModal();">Alterar</a>

</div>

<div class="modal" [class.active]="modal">

  <div class="backdrop" (click)="hideModal()"></div>

  <div class="content">

    <div>
      <div class="top-bar">
        <p class="title">Sons</p>
        <a class="close-button" (click)="hideModal()">&times;</a>
      </div>

      <div class="audio-list" [class.scroll]="audioList.length > 7">
        <app-audio-player *ngFor="let item of audioList; let i = index" [audio]="item" (click)="selectAudio(i)"
          [class.selected]="selectedOption.name === item.name" [title]="notificationType" [index]="i + 1"></app-audio-player>
      </div>
  
    </div>

    <div class="bottom-bar">
      <lib-button-tertiary id="no-button" (click)="hideModal();">Cancelar</lib-button-tertiary>
      <lib-button-primary id="yes-button" (click)="hideModal(); updateAudio()">Salvar</lib-button-primary>
    </div>

  </div>

</div>